export default __webpack_public_path__ + "static/media/pdfLogo.dd34564f.jpg";